import getLang from 'I18n/utils/getLang';
import { GET_SUGGESTION_SECTIONS_QUERY as PUBLIC_GET_SUGGESTION_SECTIONS_QUERY } from '../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationPublicRpc.dfc.new';
import {
  ProductType,
  SuggestionSectionContext,
} from '../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc';
import { GET_SUGGESTION_SECTIONS_QUERY } from '../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc.dfc.new';
import {
  DEFAULT_MAX_SECTION_CARD_COUNT,
  DEFAULT_MAX_SECTIONS,
  DEFAULT_MIN_SECTION_CARD_COUNT,
} from '../constants/suggestions';
import { usePersonalizationQuery } from './usePersonalizationQuery';

interface UseGetSuggestionSectionsOptions {
  contexts?: SuggestionSectionContext[];
  maximumSectionCardCount?: number;
  maximumSections?: number;
  minimumSectionCardCount?: number;
  productTypes?: ProductType[];
  skip?: boolean;
}

export function useGetSuggestionSections(
  options?: UseGetSuggestionSectionsOptions
) {
  return usePersonalizationQuery({
    public: PUBLIC_GET_SUGGESTION_SECTIONS_QUERY,
    app: GET_SUGGESTION_SECTIONS_QUERY,
    options: {
      skip: options?.skip,
      variables: {
        maximumSections: options?.maximumSections ?? DEFAULT_MAX_SECTIONS,
        language: getLang(),
        minimumSectionCardCount:
          options?.minimumSectionCardCount ?? DEFAULT_MIN_SECTION_CARD_COUNT,
        maximumSectionCardCount:
          options?.maximumSectionCardCount ?? DEFAULT_MAX_SECTION_CARD_COUNT,
        productTypes: options?.productTypes || ['APP', 'AGENT'],
        contexts: options?.contexts ?? [],
      },
    },
  });
}
